export enum TariffType {
  Simple = 0,
  Differential = 1,
  Hourly = 2,
}
